var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ThemeBreakpoints, ThemePalette } from "../../../../theme/_Types";
import * as I18n from "../../../../utils/translations/I18n";
import { Container } from "../../03-base/Container";
import { FlexColumn } from "../../03-base/Flex/Column";
import { FlexRow } from "../../03-base/Flex/Row";
import { FillUp } from "../../04-helpers/FillUp";
import { Button } from "../../05-atoms/Button";
import { IconNames } from "../../05-atoms/Icon";
import { Alignment, ButtonsWrapper, Orientation } from "../../06-molecules/ButtonsWrapper";
import { Navbar } from "../../07-organisms/Navbar";
import { NavbarIcon } from "../../07-organisms/Navbar/Icon";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "../../07-organisms/Navbar/Stack";
import { NavbarTitle } from "../../07-organisms/Navbar/Title";
import { Tabs } from "../00-blocks/Tabs";
import { ChangePassword } from "./AccountSettings/Tabs/ChangePassword";
import { General } from "./AccountSettings/Tabs/General";
/**
 *
 */
var ModalAccountSettings = /** @class */ (function (_super) {
    __extends(ModalAccountSettings, _super);
    /**
     *
     * @param props
     */
    function ModalAccountSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    /**
     *
     */
    ModalAccountSettings.prototype.render = function () {
        var _a;
        var _b, _c;
        var tabs = [{
                key: "GENERAL",
                title: (_b = I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general.title", "General")) !== null && _b !== void 0 ? _b : "",
                description: "",
                component: General,
            },
            {
                key: "CHANGE_PASSWORD",
                title: (_c = I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword.title", "Change password")) !== null && _c !== void 0 ? _c : "",
                description: "",
                component: ChangePassword,
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement(FlexRow, { isFixed: true },
                React.createElement(Navbar, { theme: {
                        palette: ThemePalette.CONTRAST_TERTIARY,
                    } },
                    React.createElement(NavbarStack, null,
                        React.createElement(NavbarStackContent, null,
                            React.createElement(NavbarTitle, null, I18n.getText("mary.09-views.03-modals.accountsettings.title", "Account settings"))),
                        React.createElement(NavbarStackRight, null,
                            React.createElement(NavbarIcon, null,
                                React.createElement(Button, { className: "scl-o-navbar__icon", icon: IconNames.TIMES, link: {
                                        onClick: this.closeModal(),
                                    } })))))),
            React.createElement(FlexRow, { theme: {
                    palette: ThemePalette.CONTRAST_PRIMARY,
                }, isScrollable: true },
                React.createElement(FillUp, null,
                    React.createElement(Container, { theme: {
                            padding: {
                                "": { y: 1 },
                                "md": { y: 2 },
                            },
                        } },
                        React.createElement(Tabs, { tabs: tabs, defaultTab: tabs[0], params: {
                                user: this.props.user,
                                onLogout: this.props.onLogout,
                            } })))),
            React.createElement(FlexRow, { isFixed: true },
                React.createElement(FlexColumn, { theme: {
                        palette: ThemePalette.CONTRAST_TERTIARY,
                    } },
                    React.createElement(Container, { theme: {
                            padding: { "": { y: 3 } },
                        } },
                        React.createElement(ButtonsWrapper, { orientations: (_a = {}, _a[ThemeBreakpoints.XS] = Orientation.HORIZONTAL, _a), alignment: Alignment.RIGHT },
                            React.createElement(React.Fragment, null,
                                React.createElement(Button, { theme: { palette: ThemePalette.CONTRAST_SECONDARY }, link: { onClick: this.closeModal() } }, I18n.getText("mary.close", "Close")))))))));
    };
    ModalAccountSettings.prototype.closeModal = function () {
        var _this = this;
        return function () { return _this.props.closeModal(_this.props.id); };
    };
    return ModalAccountSettings;
}(React.Component));
export { ModalAccountSettings };
